import { render } from "./FAQ.vue?vue&type=template&id=1795fbba&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=1795fbba&lang=scss&scoped=true"
import "./FAQ.vue?vue&type=style&index=1&id=1795fbba&lang=css"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1795fbba"]])

export default __exports__